import { useGetDocumentTypesQuery } from '../services';
import DriverDocumentTypeSection from './DriverDocumentTypeSection';

type DriverDocumentsProps = {
    driverId: string;
    editable?: boolean;
};

const DriverDocuments = ({ driverId, editable = false }: DriverDocumentsProps) => {
    const { data: documentTypes = [], isLoading } = useGetDocumentTypesQuery(undefined, {
        skip: !driverId,
    });

    if (!driverId) return null;
    if (isLoading) return <p className='text-sm text-gray-500'>Cargando documentos...</p>;
    if (documentTypes.length === 0) {
        return <p className='text-sm text-gray-500'>No hay tipos de documento configurados.</p>;
    }

    return (
        <section className='flex flex-col gap-6'>
            <h2 className='text-xl font-bold text-gray-800'>Documentación</h2>
            <div className='flex flex-col gap-6'>
                {documentTypes.map((type) => (
                    <DriverDocumentTypeSection
                        key={type.id}
                        driverId={driverId}
                        documentTypeId={type.id}
                        documentTypeName={type.name}
                        editable={editable}
                    />
                ))}
            </div>
        </section>
    );
};

export default DriverDocuments;
